module.exports = [{"type":"title","text":"2025-07-11"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"賬戶與錢包：主賬戶充值地址、創建子帳戶充值地址和查詢子賬戶充值地址的響應增加wallType字段。"},{"type":"html","text":"賬戶與錢包：提幣記錄、充值記錄和查詢子賬號充值記錄的入參增加txId字段。"},{"type":"html","text":"賬戶與錢包：查詢幣種充提數據入參和響應增加displayName字段。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-07-11.json
// module id = Di8Z
// module chunks = 3